import React, { useState } from "react";
import Select from "react-select";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { getCookie, options } from "./helpers";
import "./styles.css";
import { useHistory } from 'react-router-dom';
import { useLogout } from '../../network';

export const Sidebar = () => {
    const [openNested1, setOpenNested1] = useState(false);
    const [openNested2, setOpenNested2] = useState(false);

    const { t, i18n } = useTranslation();
    const location = useLocation()

    const { mutate: logout } = useLogout()

    const onChangeLanguage = (event) => {
        const { value } = event;
        i18n.changeLanguage(value);
        window.location.reload();
    };

    const getDefaultLabel = options.find(
        (item) => item.value === getCookie("locale")
    );

    const toggleMenuHandler = (id) => {
        const actions = {
            9: () => setOpenNested1((prev) => !prev),
            12: () => setOpenNested2((prev) => !prev),
        };
        if (id === 9 || id === 12) return actions[id]()
        else return
    };

    const data = [
        {
            id: 1,
            title: `${t("Orders")}`,
            name: "orders",
            icon: "/menuicon/orders.svg",
            path: "/chain/orders",
        },
        // {
        //     id: 2,
        //     title: `${t("Sales")}`,
        //     icon: "/menuicon/barchart.svg",
        //     path: "#",
        // },
        {
            id: 3,
            title: `${t("Dashboards")}`,
            name: "dashboard",
            icon: "/menuicon/analyticsalt.svg",
            path: "/chain/dashboard",
        },
        {
            id: 4,
            title: `${t("Promo Baners")}`,
            name: "banners",
            icon: "/menuicon/promo.svg",
            path: "/chain/banners",
        },
        {
            id: 5,
            title: `${t("Clients")}`,
            name: "clients",
            icon: "/menuicon/clients.svg",
            path: "/chain/clients",
        },
        {
            id: 6,
            title: `${t("Menu")}`,
            name: "menu",
            icon: "/menuicon/book.svg",
            path: "/chain/menu",
        },
        {
            id: 7,
            title: `${t("Stores")}`,
            name: "stores",
            icon: "/menuicon/stores.svg",
            path: "/chain/stores",
        },
        {
            id: 8,
            title: `${t("Teams")}`,
            name: "users",
            icon: "/menuicon/users.svg",
            path: "/chain/users",
        },
        {
            id: 9,
            title: `${t("Design")}`,
            icon: "/menuicon/design.svg",
            arrow: "/menuicon/arrow.svg",
            nested1: [
                {
                    id: 91,
                    title: `${t("Web App")}`,
                    name: "design",
                    icon: "/menuicon/web.svg",
                    path: "/chain/design",
                },
                {
                    id: 92,
                    title: `${t("Mobile App")}`,
                    name: "app",
                    icon: "/menuicon/smartphone.svg",
                    path: "/chain/app",
                },
            ],
        },
        // {
        //     id: 10,
        //     title: `${t("QR Codes")}`,
        //     icon: "/menuicon/qrcode.svg",
        //     path: "#",
        // },
        // {
        //     id: 11,
        //     title: `${t("Support")}`,
        //     icon: "/menuicon/support.svg",
        //     path: "#",
        // },
        {
            id: 12,
            title: `${t("Profile")}`,
            icon: "/menuicon/profile.svg",
            arrow: "/menuicon/arrow.svg",
            nested2: [
                {
                    id: 121,
                    title: `${t("Settings")}`,
                    name: "settings",
                    icon: "/menuicon/settings.svg",
                    path: "/chain/settings",
                },
                {
                    id: 122,
                    title: `${t("Log Out")}`,
                    name: "logout",
                    icon: "/menuicon/logout.svg",
                    path: "/logout",
                },
            ],
        },
    ];

    const onLogout = () => {
        logout()
    }

    return (
        <div className="sidebar border-r">
            <nav className="navbar" id="sidebar">
                <a href="/login" className="logo">
                    <img src="/menuicon/logoicon.svg" alt="logo-cheqit" />
                </a>

                <ul className="navbar-nav">
                    {data.map(({ id, title, icon, path, nested1, nested2, arrow, name}) => (
                            <span key={id}>
                                <a href={path}>
                                    <li className={location.pathname.split('/').includes(name) ? "active_link" : ""}
                                        onClick={() => toggleMenuHandler(id)}>
                                        <div className={ nested1 || nested2
                                            ? "black-white whitespace-nowrap flex justify-between"
                                            : "nav-link whitespace-nowrap flex justify-between"}>
                                            <div>
                                                <img
                                                    className="sidebarImg"
                                                    src={icon}
                                                    alt={title}/>
                                                <span>{title}</span>
                                            </div>
                                            {arrow && ( <img className="arrow" src={arrow} alt={arrow}/>)}
                                        </div>
                                    </li>
                                </a>
                                <ul>
                                    {nested1 && nested1.map(({ id, title, icon, path, name }) => (
                                        <li className={ openNested1
                                                ? "nav-link-nested-open whitespace-nowrap"
                                                : "nav-link-nested-close whitespace-nowrap"}
                                            key={id}>
                                            <a  href={path}
                                                className={
                                                    location.pathname.split('/').includes(name)
                                                        ? "active_link nested-href" : "nested-href"}>
                                                <img
                                                    className="nestedImg"
                                                    src={icon}
                                                    alt={title}
                                                />
                                                <span>{title}</span>
                                            </a>
                                        </li>))}
                                </ul>

                                <ul>
                                    {nested2 && nested2.map(({ id, title, icon, path, name }) => (
                                        <li className={ openNested2
                                                ? "nav-link-nested-open whitespace-nowrap"
                                                : "nav-link-nested-close whitespace-nowrap"}
                                            key={id}>
                                            {name !== 'logout' ? (
                                                <a href={path} className={location.pathname.split('/').includes(name) ? 'active_link nested-href' : 'nested-href'}>
                                                    <img className="nestedImg" src={icon} alt={title} />
                                                    <span>{title}</span>
                                                </a>
                                            ) : (
                                                <span onClick={onLogout} className={location.pathname.split('/').includes(name) ? 'active_link nested-href' : 'nested-href'}>
                                                    <img className="nestedImg" src={icon} alt={title} />
                                                    <span>{title}</span>
                                                </span>
                                            )}
                                        </li>))}
                                </ul>
                            </span>
                        )
                    )}
                </ul>
                <div className="divider" />

                <div className="languageSelect">
                    <Select
                        onChange={onChangeLanguage}
                        isLoading={false}
                        options={options}
                        defaultValue={getDefaultLabel}
                        isSearchable={false}
                        theme={(theme) => ({...theme, borderRadius: "5px"})}
                    />
                </div>
            </nav>
        </div>
    );
};
